import { NgModule }                              from '@angular/core';
import { Routes, RouterModule }                  from '@angular/router';
import { AuthGuard }                             from '../../core/auth/guards/auth.guard';
import { CargosModelosResolver }                 from '../../core/resolvers/cargos-modelos.resolver';
import { CargosModelosComponent }                from './components/cargos-modelos/cargos-modelos.component';
import { CargosModelosDetalhesComponent }        from './components/cargos-modelos-detalhes/cargos-modelos-detalhes.component';
import { CargosModelosCadastrarComponent }       from './components/cargos-modelos-cadastrar/cargos-modelos-cadastrar.component';
import { CargosModelosAtualizarComponent }       from './components/cargos-modelos-atualizar/cargos-modelos-atualizar.component';

const cargosModelosRoutes: Routes = [

  { path: 'cargos-modelo', canActivate: [AuthGuard],
    data: { breadcrumbs: 'Cargos Modelo' },
    children: [
      { path: '', component: CargosModelosComponent, canActivate: [AuthGuard] },
      { path: 'cadastrar', component: CargosModelosCadastrarComponent, canActivate: [AuthGuard],
        data: { breadcrumbs: 'Cadastrar Cargo Modelo' } },

      { path: ':IdS', canActivate: [AuthGuard],
        resolve: { cargosResolver: CargosModelosResolver },
        data: { breadcrumbs: '{{ cargosResolver.titulo }}' },
        children: [
          { path: '', component: CargosModelosDetalhesComponent, canActivate: [AuthGuard] },
          { path: 'atualizar', component: CargosModelosAtualizarComponent, canActivate: [AuthGuard],
            resolve: { cargosResolver: CargosModelosResolver },
            data: { breadcrumbs: 'Atualizar Cargo Modelo' } },
        ]
      }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(cargosModelosRoutes)],
  exports: [RouterModule]
})
export class CargosModelosRoutingModule { }

